export default "__VITE_ASSET__DRTQ$IEI__"